import useSearchAlertsService from 'api/services/searchAlertsService'
import PageLoading from 'components/common/loading/PageLoading'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

const ConfirmSearchAlertPage = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')?.trim() || ''
  const { confirmAlert } = useSearchAlertsService()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      if (!token) {
        if (!cancelled) setStatus('error')
        return
      }
      const result = await confirmAlert(token)
      if (cancelled) return
      setStatus(result ? 'success' : 'error')
    }
    void run()
    return () => {
      cancelled = true
    }
    // confirmAlert is recreated each render; only re-run when token changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  if (status === 'loading') {
    return <PageLoading />
  }

  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      {status === 'success' ? (
        <>
          <h1 className="text-2xl font-bold text-imovSecondary">
            {t('listing.alertConfirm.successTitle')}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            {t('listing.alertConfirm.successBody')}
          </p>
          <Link
            to="/account#my-space-alerts"
            className="mt-6 inline-flex min-h-[44px] items-center justify-center rounded-full bg-imovPrimary px-5 py-2.5 text-sm font-semibold text-white hover:bg-imovPrimaryDark"
          >
            {t('listing.empty.alertSeeMyAlerts')}
          </Link>
        </>
      ) : (
        <>
          <h1 className="text-2xl font-bold text-imovSecondary">
            {t('listing.alertConfirm.errorTitle')}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">
            {t('listing.alertConfirm.errorBody')}
          </p>
          <Link
            to="/listings"
            className="mt-6 inline-flex min-h-[44px] items-center justify-center rounded-full bg-imovPrimary px-5 py-2.5 text-sm font-semibold text-white hover:bg-imovPrimaryDark"
          >
            {t('listing.alertConfirm.backToListings')}
          </Link>
        </>
      )}
    </div>
  )
}

export default ConfirmSearchAlertPage
